import { Division, FlightRoomUser, JobTitle } from '@connect-x-app/shared-domain-models';

export class UserUtil {
  static getFullName(user?: FlightRoomUser): string {
    const firstName = user?.firstName ?? '';
    const lastName = user?.lastName ?? '';

    if (!firstName && !lastName) {
      return '';
    }

    return [firstName, lastName].filter(name => !!name).join(' ');
  }

  static getDivision(jobTitle?: JobTitle) {
    switch (jobTitle) {
      case JobTitle.ACM:
        return Division.ACM;
      case JobTitle.ADMINISTRATOR:
        return Division.ADMINISTRATOR;
      case JobTitle.CABIN_CREW:
        return Division.CABIN_CREW;
      case JobTitle.CCM:
        return Division.CCM;
      case JobTitle.COMM:
        return Division.COMM;
      case JobTitle.COPILOT:
        return Division.COPILOT;
      case JobTitle.DEADHEAD:
        return Division.DEADHEAD;
      case JobTitle.DISPATCHER:
        return Division.DISPATCHER;
      case JobTitle.GH:
        return Division.GH;
      case JobTitle.GROUND_HANDLER:
        return Division.GROUND_HANDLER;
      case JobTitle.MAINTENANCE_CREW:
        return Division.MAINTENANCE_CREW;
      case JobTitle.PILOT:
        return Division.PILOT;
      case JobTitle.SCCM:
        return Division.SCCM;
      case JobTitle.UNKNOWN:
      default:
        return Division.UNKNOWN;
    }
  }

  static getGuestUserString(jobTitle?: JobTitle, customName?: string | null) {
    const customLabel = customName?.trim();

    if (customLabel) {
      return `Guest (${customLabel})`;
    }

    return `Guest (${UserUtil.getDivision(jobTitle).toUpperCase()})`;
  }
}
